type Listener = () => void;

const listeners = new Set<Listener>();

/** Avisa quem está inscrito que o tenant ativo mudou (troca ou saída de conta). */
export function notifyTenantChanged(): void {
  listeners.forEach((listener) => listener());
}

/** Inscreve um listener para mudanças de tenant; retorna a função de cancelamento. */
export function subscribeTenantChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
